import { tzAxios } from 'api/axios';
import { ConcertResponse, MatchResponse } from 'api/responseTypes';

export const getEventInfo = async (eventKey: string, invitationId?: string) =>
  (
    await tzAxios.get<MatchResponse & ConcertResponse>(
      `/ticket-zone/event/v2/event/${eventKey}/info`,
      { params: invitationId ? { invitationId } : undefined },
    )
  ).data;
